import React, { Component } from "react";

import { AiFillDelete } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import {
  deleteSingleFile,
  getDepartmentList,
  getFileNameByDepartment,
} from "../../actions/MasterAction";
import Header from "../../component/common/Header";
import { onChange, setOptions } from "../../utils";
import "./../../assets/css/dltFiles.css";
import CONSTANT from "./../../constant";

export default class DltTempFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 50,
      pending: undefined,
      department: {
        name: "department",
        value: undefined,
        error: "",
        isRequired: false,
        options: [],
      },
      list: undefined,
    };
  }

  changePage = (e) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
    this.setState({ page }, () => {});
  };

  onChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === this.state.department.name) {
      value = e.target.value;
    }

    onChange(this, name, value);
  };

  shouldComponentUpdate(prevProps, prevState, snapshot) {
    if (prevState.department.value != this.state.department.value) {
      return true;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    const { department, page, limit } = this.state;
    if (prevState.department.value != this.state.department.value) {
      const model = {
        departmentCode: parseInt(department.value),
      };

      getFileNameByDepartment(model.departmentCode, page, limit).then(
        async (res) => {
          this.setState({ list: res.result });
        }
      );
    }
  }

  componentDidMount() {
    getDepartmentList().then(async (res) => {
      setOptions(this, this.state.department.name, res.result);
      // this.setState({dptValue:res.result})
    });
  }

  dltFile(dltItemData) {
    const { department, page, limit } = this.state;
    const model = {
      fileData: dltItemData,
    };
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteSingleFile(model.fileData).then((res) => {
          if (res.status == CONSTANT.static.apiStatus.success) {
            toast(`${res.result.originalFileName} deleted`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

            setTimeout(() => {
              getFileNameByDepartment(
                parseInt(this.state.department.value),
                page,
                limit
              ).then(async (res) => {
                this.setState({ list: res.result });
              });
            });
          }
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  }

  render() {
    const { department, dptValue, limit, page, list } = this.state;

    return (
      <div className="container-fluid">
        <ToastContainer />

        <div className="row">
          {/* <div className="col-md-2 px-0">
            <Header />
          </div> */}
          <div className="col-md-12">
            <div className="card homedob p-4 mb-4">
              <div className="row mt-3">
                <div className="col-md-7">
                  <h3 className="page-title">Delete Files</h3>
                </div>
                <div className="col-md-5">
                  <div className="dltfiles">
                    <div className="sltdpt">
                      <p className="heading text-nowrap"> Select Department </p>
                    </div>

                    {department.options.length > 0 ? (
                      <div>
                        <select
                          onChange={this.onChange}
                          class="form-select"
                          aria-label="Default select example"
                          name={department.name}
                        >
                          <option value=""> Select Department </option>

                          {Array.from(department.options).map((ele, index) => {
                            return (
                              <option value={ele.code} key={index}>
                                {" "}
                                {ele.name}{" "}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    ) : (
                      "hi"
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <div className="delete-file-list-container">
                    <table className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Intiated By</th>
                          <th scope="col">Department</th>
                          <th scope="col">createdOn</th>
                          <th scope="col">File Name</th>
                          <th scope="col">Delete </th>
                        </tr>

                        {list &&
                          list.map((item, index) => {
                            const currentItem = this;
                            // const detailPageURL = CONSTANT.component.userFileDetail.url.replace(':code', item.code);
                            // const dated = getDateParts(item.dated);
                            // const mo = getDateParts(item.modifiedOn);
                            // const co = getDateParts(item.closedOn);
                            // const subjectStr = item.subject.length > 50 ? item.subject.substr(0, 50) + '...' : item.subject;
                            // const openDateStr = moment(`${dated.year}-${dated.month}-${dated.date}`);
                            // const closedDateStr = moment(`${co.year}-${co.month}-${co.date}`);

                            // const diff = Math.abs(Math.floor(moment.duration(closedDateStr.diff(openDateStr)).asDays())) + 1;

                            return (
                              <tr key={index} className="c-pointer">
                                {<td> {(page - 1) * limit + index + 1} </td>}

                                {/* {
                                                                (userDetail.isHOD || userDetail.code === item.createdBy) ? <td>
                                                                    {
                                                                        isClosed ? 'File is closed' : `${item.pendingWithName}`
                                                                    }
                                                                </td> : <td>-</td>
                                                            } */}

                                <td
                                  onClick={(e) =>
                                    this.props.history.push(
                                      `${CONSTANT.component.userFileList.url}/${item.fileCode}`
                                    )
                                  }
                                >
                                  {item.intiatedBy}
                                </td>
                                <td> {item.name} </td>
                                <td>{item.createdOn}</td>
                                {/* <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td> */}
                                <td>
                                  {" "}
                                  <a
                                    href={`${process.env.REACT_APP_BASE_URL}_attachment/${item.fileCode}/${item.fileName}`}
                                    download
                                  >
                                    {" "}
                                    {item.originalFileName}{" "}
                                  </a>{" "}
                                </td>
                                {/* <td><b>{diff === 0 ? 'Closed Today' : diff}</b></td> */}
                                <td className="dltItem">
                                  <AiFillDelete
                                    className="dltHover"
                                    onClick={(e) => {
                                      this.dltFile(item);
                                    }}
                                    size={30}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}
